import { createService } from '@bonanza-social/toolkit/api';
import { GlobalAlertResponseSchema } from './GlobalAlertService.schemas';

export default createService({
  getGlobalAlert: {
    method: 'GET',
    url: '/notifications/lobby/globalAlert',
    responseSchema: GlobalAlertResponseSchema,
  },
});
